import { render } from "./nav-bar.vue?vue&type=template&id=876e8028"
import script from "./nav-bar.vue?vue&type=script&lang=js"
export * from "./nav-bar.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__